import axios from "axios";
import dayjs from "dayjs";
import { CONSTANTS, getErrorMessage } from "../global/index";
const {
  ERROR_MSG,
  ERROR_STATUS,
} = CONSTANTS;
const ERROR_OBJ = {
  success: false,
  status: ERROR_STATUS,
  code: 500,
  message: ERROR_MSG,
  data: null
};


export default {
  setToken(token) {
    localStorage.setItem("tkn", token);
  },

  getToken() {
    const token = localStorage.getItem("tkn");
    if(!token) return null
    return token
  },

  isAdmin(user) {
    if (user?.role !== "admin" && user.role !== "legrafica") return { admin: false, type: user.role }
    return { admin: true, type: user.role };
  },

  async tokenexp() {
    try {
        const response = await this.getData();
        if (!response.success) return { exp: true, response };

        const identity = response.data;
        const identity_exp = new Date(0).setUTCSeconds(identity.exp);
        const date = dayjs().valueOf();
        const exp = date > identity_exp;
        return { exp , response };
    } catch ( error ) {
      if(!error?.response?.data?.message) return  ERROR_OBJ;
      return getErrorMessage(error.response.data.message)
    }
  },

  async getData() {
    try {
      const token = this.getToken();
      if (token === null) return getErrorMessage('Token no valido, vuelve a iniciar sesión.')
      const headers = { Authorization: token };
      const response = await axios.post(`/validate-token`, null, { headers });
      return response.data;
    } catch (error) {
      if(!error?.response?.data?.message) return  ERROR_OBJ;
      return getErrorMessage(error.response.data.message)
    }
  },

  async verify() {
    return
    const pathname = window.location.pathname;
    if (!pathname) return;
    const paths = ['web-app'];
    const includes = paths.some(path => pathname.includes(path));
    if(!includes) return;

    const response = await this.getData()
   
    if(pathname.includes(paths[0]) && !response.success){
      window.location.href = '/login';
    }
    
    if(pathname.includes(paths[1]) && !response.success){
      window.location.href = '/iniciar-sesion';
    }
  },

  async checkAuth() {
    const token = this.getToken();
    if (token === null) return false

    try {
      const headers = { Authorization: token };
      const response = await axios.post(
        `/check-auth`,
        null,
        { headers }
      );

      return response.data.success
    } catch (error) {
      localStorage.removeItem("tkn")
      return false
    }
  },
};
